export const formatter = ({ temporaryChanges = [] }) => ({
  vehicles: temporaryChanges.map(({ uuid, vcCategoryUuid, vcSubcategoryUuid }) => ({
    uuid,
    vcCategoryUuid,
    vcSubcategoryUuid,
  })),
});
